if (!customElements.get('learn-process-reveal')) {
  class LearnProcessReveal extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;

      const step = 160;
      this.querySelectorAll('.learn-process__step').forEach((li, i) => {
        const card = li.querySelector('.learn-process__card');
        if (card) card.style.setProperty('--reveal-delay', `${i * 2 * step}ms`);
        li.querySelectorAll('.learn-process__paw').forEach((paw, j) => {
          paw.style.setProperty('--reveal-delay', `${(i * 2 + 1) * step + j * (step / 2)}ms`);
        });
      });

      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          requestAnimationFrame(() => this.classList.add('is-revealed'));
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('learn-process-reveal', LearnProcessReveal);
}
